import React from 'react';
import Icon from '../shared/Icon';
import Avatar from '../shared/Avatar';

const NAV_ITEMS = [
  { id: 'overview', label: 'Overview',      icon: 'overview' },
  { id: 'users',    label: 'History',       icon: 'users'    },
  { id: 'feedback', label: 'Feedback',      icon: 'star'     },
  { id: 'devids',   label: 'Developer IDs', icon: 'shield'   },
];

export default function AdminSidebar({ activePage, onNavigate, collapsed, accent, currentUser, product }) {
  const ac = accent || '#CC1A00';
  const bg = 'white';
  const borderC = '#E8EAED';
  const txtColor = '#374151';
  const mutedColor = '#9CA3AF';

  return (
    <nav style={{
      width: collapsed ? 64 : 248,
      background: bg,
      borderRight: '1px solid ' + borderC,
      display: 'flex', flexDirection: 'column',
      height: '100vh', position: 'fixed', left: 0, top: 0,
      transition: 'width 0.22s cubic-bezier(.4,0,.2,1)',
      overflow: 'hidden', zIndex: 20, flexShrink: 0,
    }}>
      {/* Logo */}
      <div style={{ padding: '16px 14px', borderBottom: '1px solid ' + borderC, flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{
            width: 34, height: 34, background: ac, borderRadius: 8,
            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
          }}>
            <span style={{ color: 'white', fontWeight: 900, fontSize: 16, letterSpacing: '-1px' }}>A</span>
          </div>
          {!collapsed && (
            <div style={{ overflow: 'hidden', whiteSpace: 'nowrap' }}>
              <div style={{ fontWeight: 700, fontSize: 13, color: '#111827' }}>Ascent Admin</div>
              <div style={{ fontSize: 11, color: mutedColor }}>{product || 'Analytics Dashboard'}</div>
            </div>
          )}
        </div>
      </div>

      {/* Nav items */}
      <div style={{ flex: 1, padding: '10px 8px', overflow: 'auto' }}>
        {NAV_ITEMS.map(item => {
          const active = activePage === item.id;
          const accentLight = ac + '18';
          return (
            <button
              key={item.id}
              onClick={() => onNavigate(item.id)}
              title={collapsed ? item.label : ''}
              style={{
                display: 'flex', alignItems: 'center', gap: 10,
                width: '100%', padding: '10px 12px', borderRadius: 8,
                border: 'none', cursor: 'pointer', fontFamily: 'inherit',
                background: active ? (ac + '18') : 'transparent',
                color: active ? ac : txtColor,
                fontWeight: active ? 600 : 400,
                fontSize: 14, marginBottom: 2,
                transition: 'background 0.12s',
                textAlign: 'left', whiteSpace: 'nowrap',
              }}
            >
              <Icon name={item.icon} size={18} color={active ? ac : mutedColor} />
              {!collapsed && <span>{item.label}</span>}
            </button>
          );
        })}
      </div>

      {/* Bottom user row — real user from session, no hardcoding */}
      <div style={{ padding: '10px 8px', borderTop: '1px solid ' + borderC, flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px' }}>
          <Avatar name={currentUser?.name || currentUser?.email || 'A'} size={30} bg={ac} />
          {!collapsed && (
            <div style={{ overflow: 'hidden', whiteSpace: 'nowrap' }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {currentUser?.name || 'Admin'}
              </div>
              <div style={{ fontSize: 10, color: mutedColor, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {currentUser?.email || ''}
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
